import { render, staticRenderFns } from "./wishlis.vue?vue&type=template&id=ef1dbe58&scoped=true&"
import script from "./wishlis.vue?vue&type=script&lang=js&"
export * from "./wishlis.vue?vue&type=script&lang=js&"
import style0 from "./wishlis.vue?vue&type=style&index=0&id=ef1dbe58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1dbe58",
  null
  
)

export default component.exports